const routes = {
  '/': 'หน้าหลัก',
  '/dashboard/admin': 'หน้าหลัก',
  '/dashboard/sale': 'หน้าหลัก',

  '/login': 'Login',
  '/#/login': 'Login',
  '/components': 'Components',
  '/charts': 'Charts',
  '/components/buttons': 'Buttons',
  '/components/social-buttons': 'Social Buttons',
  '/components/cards': 'Cards',
  '/components/forms': 'Forms',
  '/components/modals': 'Modals',
  '/components/switches': 'Switches',
  '/components/tables': 'Tables',
  '/components/tabs': 'Tabs',
  '/icons': 'Icons',
  '/icons/font-awesome': 'Font Awesome',
  '/icons/simple-line-icons': 'Simple Line Icons',

  '/cars/list': 'ข้อมูลรถ',
  '/cars/albums': 'ข้อมูลอัลบั้มรถ',
  '/cars/freelance': 'ข้อมูลรถ-ฟรีแลนซ์',
  '/cars/new': 'เพิ่มข้อมูลรถ',
  '/cars/detail/': 'รายละเอียดรถ',
  '/car-repair/list': 'ข้อมูลการซ่อมบำรุงรถ',
  '/car-repair/new': 'ข้อมูลการซ่อมบำรุง',
  '/customer/list': 'ข้อมูลลูกค้า',
  '/customer/credit-profile': 'ข้อมูลเครดิตลูกค้า',
  '/customer/credit-profile-form': 'ข้อมูลเครดิตลูกค้า',
  '/sales/list': 'ข้อมูลการขายรถ',
  '/car-sell/detail/': 'รายละเอียดการขายรถ',
  '/debtors/list': 'ข้อมูลบัญชีลูกหนี้',
  '/debtors/payment-detail/': 'รายละเอียดผ่อนชำระ',
  '/carfinance/list': 'CarFinanceList',
  '/bank/list': 'ข้อมูลธนาคาร',
  '/maintenance/list': 'ข้อมูลศูนย์ซ่อมบำรุง',
  '/calendar/list': 'ปฏิทินเตือนความจำ',
  '/branch/list': 'ข้อมูลสาขา',
  '/account/list': 'ข้อมูลผู้ใช้งาน',
  '/cars/book': 'การจองรถ',
  '/cars/book-cancel': 'ยกเลิกการจอง',
  '/sales/buy/': 'การขายรถ',
  '/employee/list': 'ข้อมูลพนักงาน',
  '/expense/list': 'ค่าใช้จ่ายของเต็นท์รถ',
  '/receipts/list': 'รายรับของเต็นท์รถ',
  '/car-reservation/list': 'ข้อมูลการจองรถ',
  '/sales/claim': 'ออกใบเคลม',
  '/car-claim/list': 'รายการเคลมรถ',
  '/car-claim/items': 'รายการซ่อมเคลม',
  '/sparepart': 'ข้อมูลอะไหล่',
  '/carin/all': 'ข้อมูลรถในเต็นท์',
  '/customer/findcar': 'ลูกค้าหารถ',
  '/customer/findcar/add': 'เพิ่มลูกค้าหารถ',
  '/car-check/': 'ประเมินทำสีรถ',
  '/carcheck/list': 'รายการประเมินทำสีรถ',
  '/customer/followup/tab': 'ติดตามลูกค้า',
  '/customer/followup/list': 'รายการติดตามลูกค้า',
}
export default routes
